import CortanaComposeStore from './schema/CortanaComposeStore';
import createCortanaComposeViewState from '../utils/createCortanaComposeViewState';
import { createStore } from 'satcheljs';

const cortanaComposeStoreData: CortanaComposeStore = {
    viewState: createCortanaComposeViewState({}),
    cachedDoradoSearchResults: null,
    currentSearchCorrelationId: undefined,
};

export let getStore = createStore<CortanaComposeStore>('cortanaCompose', cortanaComposeStoreData);

const cortanaComposeStore = getStore();
export default cortanaComposeStore;
